var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48867 11.296C5.81401 11.296 5.47667 10.9513 5.47667 10.262V6.654H1.93467C1.27467 6.654 0.944672 6.33133 0.944672 5.686C0.944672 5.04067 1.27467 4.718 1.93467 4.718H5.47667V1.22C5.47667 0.545333 5.81401 0.208 6.48867 0.208C7.16334 0.208 7.50067 0.545333 7.50067 1.22V4.718H11.0427C11.7027 4.718 12.0327 5.04067 12.0327 5.686C12.0327 6.33133 11.7027 6.654 11.0427 6.654H7.50067V10.262C7.50067 10.9513 7.16334 11.296 6.48867 11.296Z",
    fill: "#224B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3b75d86db88b0e8cca8cda56cd5ccef6.svg";
export { ForwardRef as ReactComponent };